import { render, staticRenderFns } from "./videoRoomxbk.vue?vue&type=template&id=56b87bf4&scoped=true"
import script from "./videoRoomxbk.vue?vue&type=script&lang=js"
export * from "./videoRoomxbk.vue?vue&type=script&lang=js"
import style0 from "./videoRoomxbk.vue?vue&type=style&index=0&id=56b87bf4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b87bf4",
  null
  
)

export default component.exports